import React, { useEffect, useRef } from "react";
import "./HoppersGallery.scss"
import Button from "../../components/Button/Button";
import { sortByOrderAscending } from "../../helper/helper";
import { useDispatch, useSelector } from "react-redux";
import { setIsComing } from "../../../../../../../redux/companyDataSlice";


const HoppersGallery = () => {
    const containerRef = useRef(null);
    const contentRef = useRef(null);
    const pages = useSelector((state) => state.companyData.pages)

    const page = pages.find((page) => page.PageId === "gallery")
    const dispatch = useDispatch()
    const Components = page?.Components || []
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    useEffect(() => {
        const container = containerRef.current;
        const content = contentRef.current;

        if (!container || !content) return;

        let scrollLeft = 0;
        let animationFrame;

        const clone = content.cloneNode(true);
        container.appendChild(clone);

        const animate = () => {
            scrollLeft += 0.5;
            if (scrollLeft >= content.scrollWidth) {
                scrollLeft = 0;// Reset seamlessly
            }
            container.scrollLeft = scrollLeft;
            animationFrame = requestAnimationFrame(animate);
        };

        animationFrame = requestAnimationFrame(animate);

        return () => cancelAnimationFrame(animationFrame);
    }, []);

    const getHeroComponent = (component) => {
        switch (component.ID) {
            case "HoppersGallery-Hero-header":
                return <div className="HoppersGallery-Hero-header">
                    {component?.Props?.text}
                </div>
            case "HoppersGallery-Hero-subheader":
                return <div className="HoppersGallery-Hero-subheader">
                    {component?.Props?.text1}<br />
                    {component?.Props?.text2}
                </div>
            case "HoppersGallery-Hero-cont":
                return <div className="HoppersGallery-Hero-cont">
                    {component?.Props?.text}
                </div>
            default:
                return <div />
        }

    }
    const getHeroContent = (components, heroBackground) => {
        return (
            <div className="HoppersGallery-Hero"
                style={{
                    backgroundImage: `linear-gradient(#00000099,#00000099), url(${heroBackground})`
                }}>
                {sortByOrderAscending(components).map((component, key) => {
                    return (
                        getHeroComponent(component)
                    )
                })}
            </div>
        )
    }
    const getGalleryComponent = (component) => {
        switch (component.ID) {
            case "HoppersGallery-Container-header":
                return <div className="HoppersGallery-Container-header">
                    {component?.Props?.text}
                </div>
            case "HoppersGallery-Container-subheader":
                return <div className="HoppersGallery-Container-subheader">
                    {component?.Props?.text}
                </div>
            case "HoppersGallery-Container-grid":
                return <div className="HoppersGallery-Container-grid">
                    {component?.Data.map((data, key) => {
                        return (
                            <img alt="" src={data?.src} key={key} />
                        )
                    })}
                </div>
            default:
                return <div />
        }

    }
    const getGalleryContent = (components) => {
        return (
            <div className="HoppersGallery-Container">
                {sortByOrderAscending(components).map((component, key) => {
                    return (
                        getGalleryComponent(component)
                    )
                })}
            </div>
        )
    }
    const getBookComponent = (component) => {
        switch (component.ID) {
            case "HoppersGallery-bottom-header":
                return <div className="HoppersGallery-bottom-header">
                    {component?.Props?.text}
                </div>
            case "HoppersGallery-bottom-subheader":
                return <div className="HoppersGallery-bottom-subheader">
                    {component?.Props?.text}
                </div>
            case "HoppersGallery-bottom-btn":
                return <div className="HoppersGallery-bottom-btn">
                    <Button
                        text={component?.Props?.btnText}
                        width={component?.Props?.width}
                        onClick={() => {
                            if (component?.Props?.href && component?.Props?.href?.includes("https://")) {
                                window.open(component?.Props?.href, '_blank')
                            } else {
                                dispatch(setIsComing(true))
                            }
                        }} />
                </div>
            default:
                return <div />
        }

    }
    const getBookContent = (components, bottomBackground) => {
        return (
            <div className="HoppersGallery-bottom"
                style={{
                    backgroundImage: `linear-gradient(#000000B2,#000000B2), url(${bottomBackground})`
                }}>
                {sortByOrderAscending(components).map((component, key) => {
                    return (<div key={key}>
                        {getBookComponent(component)}
                    </div>)
                })}
            </div>
        )
    }
    const getImagesCarousel = (data) => {
        return (
            <div className="HoppersGallery-ImageCarousel" ref={containerRef}>
                <div className="HoppersGallery-Cont" ref={contentRef}>
                    {data?.map((data, index) => (
                        <img key={index} src={data?.src} alt={`img-${index}`} className="HoppersGallery-Cont-image" />
                    ))}
                </div>
            </div>
        )
    }
    const getComponents = (component) => {
        switch (component.ID) {
            case "HoppersGallery-Hero":
                return getHeroContent(component.Components, component?.Props?.bgSrc)
            case "HoppersGallery-Container":
                return getGalleryContent(component.Components)
            case "HoppersGallery-bottom":
                return getBookContent(component.Components, component?.Props?.bgSrc)
            case "HoppersGallery-ImageCarousel":
                return getImagesCarousel(component.Data)
            default:
                return <div />
        }

    }
    return (
        <div className="HoppersGallery">
            {sortByOrderAscending(Components).map((component, key) => {
                return (<div key={key}>
                    {getComponents(component)}
                </div>)
            })}
        </div >
    )
}
export default HoppersGallery